import React, { Component, createRef } from "react";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import Category from "./category";
import List from "./list/list";
import Two from "./list/two";
import Large from "./list/large";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Subcategory from "./subcategory";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Cart from "./cart";
import logo from "../../assets/logo.png";

import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

import { useLocation } from "react-router-dom";

class Menu extends Component {
  settings = this.props.Settings;
  language = this.props.Language;

  state = {
    categoriesCoffe: [],
    categoriesResturant: [],
    categoryType: "restaurant",
    selectCategory: [],
    items: [],
    slide: [],
    loadSlide: false,
    loadCat: false,
    load: false,
    listview: "two",
    cart: false,
    CategorySelect: "restaurant",
    categories: [],
    selectCategory: [],
    items: [],
    slide: [],
    menus: [],
    menuId: 0,
  };

  async componentDidMount() {
    {
      const { data } = await axios.get(
        `https://manage.caviarmenu.com/api/menuItems/norjan/${this.state.strOrderType}`
      );
      this.setState({ items: data }, () => {
        this.setState({ load: true });
      });
    }

    {
      const { data } = await axios.get(
        "https://manage.caviarmenu.com/api/menus/norjan"
      );
      this.setState({ menus: data }, () => {
        this.setState({
          loadMenus: true,
          selectCategory: data[0].categories[0],
        });
      });
    }

    this.layoutDirection();
  }

  layoutDirection() {
    if (this.props.Language != "en")
      document.getElementById("itemContainer").style.direction = "rtl";
    else document.getElementById("itemContainer").style.direction = "ltr";
  }

  getCategoryName(id) {
    if (id == 0) {
      this.setState({
        selectCategory: this.state.menus[this.props.orderType].categories[0],
      });
    } else {
      this.state.menus[this.props.orderType]?.map((cat) => {
        if (cat.id == id) this.setState({ selectCategory: cat });
      });
    }
  }

  handleChange = async (e) => {
    await this.props.handleLangaugeSubmit(e);
    this.layoutDirection();
  };

  handleCategory = async (catId) => {
    this.setState({ load: false });
    this.getCategoryName(catId);
    this.setState({ load: true });
  };

  handleListview = (style) => {
    this.setState({ listview: style });
  };

  handleCartClose = (close) => {
    this.setState({ cart: close });
  };

  constructor(props) {
    super(props);
    this.categoryRefs = {};
    this.categoryContainer = React.createRef();

    let strOrderType = "";
    if (props.orderType === 0) strOrderType = "12";
    else if (props.orderType === 1) strOrderType = "13";
    else strOrderType = String(props.orderType);

    this.state = {
      loadCat: true,
      selectedMenu: 0,
      categories: [],
      selectCategory: {},
      strOrderType: strOrderType,
    };
  }

  handleCategory = (category) => {
    this.setState({ selectCategory: category });
  };

  handleMenuClick = (e) => {
    this.setState({ loadMenus: false, load: false });
    this.setState({ orderType: e }, () => {
      this.setState({
        loadMenus: true,
        load: true,
        selectCategory: this.state.menus[e].categories[0],
      });
    });
  };
  scrollToCategory = (categoryId) => {
    const categoryRef = this.categoryRefs[categoryId];
    if (categoryRef && categoryRef.current && this.categoryContainer.current) {
      const container = this.categoryContainer.current;
      const startPosition = container.scrollLeft;

      let targetPosition = 0;
      let distance = 0;
      if (this.props.Language == "en") {
        targetPosition = categoryRef.current.offsetLeft - container.offsetLeft;
        distance = targetPosition - startPosition;
      } else {
        targetPosition =
          categoryRef.current.offsetLeft +
          categoryRef.current.offsetWidth -
          container.clientWidth;
        distance = targetPosition - startPosition;
      }

      const duration = 1500; // Duration in ms for slower scrolling (1.5 seconds)
      let startTime = null;

      const animateScroll = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const scrollProgress = Math.min(timeElapsed / duration, 1);

        // Cubic ease-in-out function for smooth scroll
        const ease =
          scrollProgress < 0.5
            ? 4 * scrollProgress * scrollProgress * scrollProgress
            : 1 - Math.pow(-2 * scrollProgress + 2, 3) / 2;

        container.scrollLeft = startPosition + distance * ease;

        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Scroll to the active category whenever it changes
    if (prevState.selectCategory?.id !== this.state.selectCategory?.id) {
      this.scrollToCategory(this.state.selectCategory.id);
    }

    if (this.state.showDisplayItems) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  render() {
    const isLtr = this.props.Language == "en";
    return (
      <div className="menu-items" onScroll={this.handleScroll}>
        <div className="head head0 ani-ttb-s" style={this.headCover}>
          <div className="head-left">
            <Link to={"/"}>
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.1719 13.8125H1.86877C1.4219 13.8125 1.05627 13.4469 1.05627 13C1.05627 12.5531 1.4219 12.1875 1.86877 12.1875H24.1719C24.6188 12.1875 24.9844 12.5531 24.9844 13C24.9844 13.4469 24.6188 13.8125 24.1719 13.8125Z"
                  fill="white"
                />
                <path
                  d="M10.7656 22.75C10.5625 22.75 10.3594 22.6688 10.1969 22.5063L1.25938 13.5688C0.934375 13.2438 0.934375 12.7563 1.25938 12.4313L10.1969 3.49375C10.5219 3.16875 11.0094 3.16875 11.3344 3.49375C11.6594 3.81875 11.6594 4.30625 11.3344 4.63125L3.00625 13L11.375 21.3687C11.7 21.6937 11.7 22.1813 11.375 22.5063C11.2125 22.6688 11.0094 22.75 10.7656 22.75Z"
                  fill="white"
                />
              </svg>
            </Link>
          </div>
          <div
            className="head-right"
            onClick={() => this.handleCartClose(true)}
          >
            <p>
              {this.props.Language === "en"
                ? "Cart"
                : this.props.Language === "krd"
                ? "سەلک"
                : "العربة "}
            </p>
            <div className=" order-btn">
              <span className="cartQty"> {this.props.SumQty} </span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.6718 3.76133C13.401 3.44867 13.0087 3.26667 12.5885 3.26667H11.2904V1.40933C11.2904 0.63 10.6553 0 9.88022 0H4.13216C3.35237 0 2.722 0.634667 2.722 1.40933V3.26667H1.4239C1.00832 3.26667 0.611417 3.444 0.340591 3.76133C0.0744334 4.06933 -0.0423022 4.47067 0.0137309 4.86733L1.17175 12.8007C1.26981 13.4867 1.87683 14 2.57724 14H11.4211C12.1215 14 12.7286 13.482 12.8266 12.8007L13.9846 4.86733C14.0453 4.47067 13.9239 4.06467 13.6578 3.76133H13.6718ZM3.65588 1.40933C3.65588 1.148 3.87067 0.933333 4.13216 0.933333H9.88022C10.1417 0.933333 10.3565 1.148 10.3565 1.40933V3.26667H3.65121V1.40933H3.65588ZM1.05034 4.368C1.14373 4.26067 1.27914 4.2 1.42857 4.2H12.5932C12.7379 4.2 12.878 4.26067 12.9714 4.368C13.0601 4.47067 13.0975 4.59667 13.0788 4.732L13.0134 5.17067H1.00832L0.942946 4.732C0.924269 4.60133 0.961624 4.47067 1.05034 4.37267V4.368ZM6.54159 10.0473V13.062H4.67382L4.47303 10.0473H6.54159ZM4.41233 9.114L4.21154 6.09933H6.54626V9.114H4.417H4.41233ZM7.47547 10.0473H9.54402L9.34324 13.062H7.47547V10.0473ZM7.47547 9.114V6.09933H9.81018L9.6094 9.114H7.48014H7.47547ZM1.14373 6.104H3.27299L3.47377 9.11867H1.58266L1.14373 6.104ZM2.10096 12.6653L1.71807 10.052H3.53448L3.73526 13.0667H2.58191C2.3391 13.0667 2.13365 12.894 2.10096 12.6653ZM11.4305 13.0667H10.2771L10.4779 10.052H12.2943L11.9114 12.6653C11.8787 12.894 11.6686 13.0667 11.4305 13.0667ZM12.4297 9.11867H10.5386L10.7394 6.104H12.8687L12.4297 9.11867Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
        <div
          className={`langModal ${
            this.state.show ? "langModalShow ani-fade-in-f" : ""
          }
          ${this.state.fadeOut ? " ani-fade-out-f" : ""}`}
        >
          <div className="langModalContainer">
            <div className="langModalHead">
              <i
                className="fa-solid fa-xmark"
                role="button"
                onClick={() => {
                  setTimeout(() => {
                    this.setState({ show: false });
                  }, 500);
                  this.setState({ fadeOut: true });
                  console.log("fadeOut", this.state.fadeOut);

                  setTimeout(() => {
                    this.setState({ fadeOut: false });
                  }, 450);
                }}
              ></i>
            </div>
            <div className="langModalBody">
              <button
                type="submit"
                className={`${
                  this.props.Language === "krd" ? "language-select-active" : ""
                }`}
                onClick={() => {
                  this.handleChange("krd");
                  this.setState({ show: false });
                }}
              >
                {" "}
                کوردی{" "}
              </button>
              <button
                type="submit"
                className={`${
                  this.props.Language === "ar" ? "language-select-active" : ""
                }`}
                onClick={() => {
                  this.handleChange("ar");
                  this.setState({ show: false });
                }}
              >
                {" "}
                العربية{" "}
              </button>
              <button
                type="submit"
                className={`${
                  this.props.Language === "en" ? "language-select-active" : ""
                }`}
                onClick={() => {
                  this.handleChange("en");
                  this.setState({ show: false });
                }}
              >
                {" "}
                English{" "}
              </button>
            </div>
          </div>
        </div>

        <div className="topLogo-and-name">
          <div className="headLogo  ani-stb">
            <Link to={"/"}>
              <img src={logo} alt="" />
            </Link>
          </div>
          <div>
            <p>
              {this.props.Language === "en" ? (
                <>
                  Norjan <br /> Restaurant
                </>
              ) : this.props.Language === "ar" ? (
                <>نورجان مطعم</>
              ) : (
                <>
                  نورجان <br /> رێستورانت
                </>
              )}
            </p>

            <div className="languageNfeedback-container">
              <div className="language">
                <div
                  className="head-btn language-active"
                  onClick={() => {
                    this.setState({ show: true });
                    let c2 = document.querySelector(".menu-2c2");
                    if (c2) c2.classList.remove("active-menu-button2");
                    let c = document.querySelector(".menu-2c");
                    if (c) c.classList.add("active-menu-button1");
                  }}
                >
                  {/* SVGs */}
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.9526 12.4495C15.6819 11.2614 16.067 9.89417 16.065 8.50013V8.49986C16.067 7.1058 15.6819 5.73858 14.9526 4.55048L14.9485 4.54399C14.2719 3.44127 13.3238 2.53047 12.1949 1.89862C11.0659 1.26678 9.79382 0.935003 8.50008 0.934998C7.20635 0.934992 5.93423 1.26676 4.80527 1.89859C3.67632 2.53043 2.72826 3.44122 2.05168 4.54394L2.04748 4.55051C1.32002 5.73942 0.935064 7.10616 0.935059 8.49997C0.935053 9.89379 1.32 11.2605 2.04745 12.4494L2.05172 12.4561C2.7283 13.5588 3.67636 14.4696 4.80531 15.1014C5.93425 15.7332 7.20636 16.065 8.50009 16.065C9.79381 16.065 11.0659 15.7332 12.1949 15.1014C13.3238 14.4695 14.2718 13.5588 14.9484 12.456L14.9526 12.4495ZM9.46704 14.7684C9.32288 14.9075 9.15696 15.0221 8.97584 15.1077C8.82717 15.1783 8.66465 15.215 8.50005 15.215C8.33546 15.215 8.17293 15.1783 8.02427 15.1077C7.67959 14.9316 7.38454 14.672 7.16609 14.3525C6.71995 13.7078 6.38933 12.9905 6.189 12.2325C6.95857 12.1851 7.72892 12.161 8.50006 12.1601C9.27087 12.1601 10.0413 12.1843 10.8112 12.2325C10.7004 12.6222 10.5619 13.0035 10.3968 13.3736C10.1794 13.894 9.86374 14.3676 9.46704 14.7684ZM1.79985 8.925H4.85118C4.87105 9.77643 4.96333 10.6246 5.12704 11.4604C4.29293 11.5338 3.46095 11.6346 2.63109 11.7628C2.14515 10.891 1.86108 9.92123 1.79985 8.925ZM2.63109 5.23715C3.46061 5.36569 4.29289 5.46653 5.12792 5.53965C4.96388 6.37537 4.87139 7.22356 4.85145 8.075H1.79985C1.86108 7.07876 2.14514 6.10898 2.63109 5.23715ZM7.53307 2.23153C7.67722 2.09243 7.84314 1.97784 8.02427 1.89227C8.17293 1.82164 8.33546 1.78499 8.50005 1.78499C8.66465 1.78499 8.82717 1.82164 8.97584 1.89227C9.32051 2.06833 9.61556 2.32797 9.83401 2.64747C10.2802 3.29215 10.6108 4.00951 10.8111 4.76748C10.0415 4.81483 9.27118 4.83896 8.50006 4.83985C7.72925 4.83984 6.95885 4.81571 6.18886 4.76747C6.29975 4.37775 6.43825 3.99643 6.60333 3.6264C6.82069 3.106 7.13637 2.63239 7.53307 2.23153ZM15.2003 8.075H12.1489C12.1291 7.22356 12.0368 6.37536 11.8731 5.53958C12.7072 5.46618 13.5392 5.36537 14.369 5.23714C14.855 6.10898 15.139 7.07876 15.2003 8.075ZM5.98194 11.3943C5.81572 10.5811 5.72183 9.75478 5.7014 8.925H11.2988C11.2786 9.75477 11.1848 10.5811 11.0188 11.3944C10.1801 11.3393 9.34055 11.3112 8.50006 11.3101C7.66018 11.3101 6.8208 11.3382 5.98194 11.3943ZM11.0182 5.60565C11.1844 6.41887 11.2783 7.24522 11.2987 8.075H5.7013C5.72155 7.24522 5.81526 6.41886 5.98134 5.60562C6.81999 5.66064 7.65956 5.68872 8.50006 5.68984C9.33994 5.68984 10.1793 5.66177 11.0182 5.60565ZM12.1486 8.925H15.2003C15.139 9.92123 14.855 10.891 14.369 11.7628C13.5395 11.6343 12.7072 11.5334 11.8722 11.4603C12.0362 10.6246 12.1287 9.77643 12.1486 8.925ZM13.8594 4.45481C13.1341 4.55945 12.4067 4.6423 11.677 4.70335C11.5459 4.21512 11.3768 3.73791 11.1712 3.27606C10.9835 2.85105 10.7474 2.44916 10.4674 2.07836C11.8203 2.49325 13.0074 3.32499 13.8594 4.45481ZM3.75181 3.75175C4.52785 2.97498 5.48258 2.40043 6.53232 2.07846C6.51639 2.09909 6.50001 2.1188 6.48431 2.13986C5.94475 2.91658 5.55172 3.78541 5.32463 4.70348C4.59497 4.64168 3.86701 4.55879 3.14074 4.45481C3.32805 4.20671 3.53222 3.9718 3.75181 3.75175ZM3.14073 12.5452C3.866 12.4405 4.59345 12.3577 5.32307 12.2966C5.4542 12.7849 5.62333 13.2621 5.8289 13.7239C6.01658 14.1489 6.25274 14.5508 6.53267 14.9216C5.17983 14.5067 3.99268 13.675 3.14073 12.5452ZM13.2483 13.2482C12.4723 14.025 11.5175 14.5996 10.4678 14.9215C10.4837 14.9009 10.5001 14.8812 10.5158 14.8601C11.0554 14.0834 11.4484 13.2146 11.6755 12.2965C12.4051 12.3583 13.1331 12.4412 13.8594 12.5452C13.6721 12.7933 13.4679 13.0282 13.2483 13.2482Z"
                      fill="white"
                    />
                  </svg>

                  <svg
                    width="9"
                    height="7"
                    viewBox="0 0 9 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 7C4.37203 7 4.24406 6.958 4.14608 6.87225L0.146967 3.37225C-0.0489891 3.20075 -0.0489891 2.92425 0.146967 2.75275C0.342924 2.58125 0.658853 2.58125 0.85481 2.75275L4.00011 5.5055V0.437499C4.00011 0.195999 4.22406 -9.50004e-07 4.5 -9.50004e-07C4.77594 -9.50004e-07 4.99989 0.195999 4.99989 0.437499V5.5055L8.14519 2.75275C8.34115 2.58125 8.65708 2.58125 8.85303 2.75275C9.04899 2.92425 9.04899 3.20075 8.85303 3.37225L4.85392 6.87225C4.75594 6.95625 4.62797 7 4.5 7Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
              <div
                className="head-btn feedback-btn"
                style={{ fontFamily: "Exo 2" }}
              >
                <Link to={"/Feedback"}>
                  <p>
                    {this.props.Language === "en"
                      ? "Feedback"
                      : this.props.Language === "krd"
                      ? "فیدباك"
                      : "فیدباك"}
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div
          className="categories ani-rtl"
          ref={this.categoryContainer}
          style={
            this.props.Language !== "en"
              ? { display: "flex", flexDirection: "row-reverse" }
              : {}
          }
        >
          {this.state.loadMenus ? (
            <>
              {this.state.menus[this.props.orderType]?.categories?.map(
                (cat, index) => {
                  if (!cat) return null;
                  if (!this.categoryRefs[cat.id]) {
                    this.categoryRefs[cat.id] = createRef();
                  }
                  if (!this.categoryRefs[cat.id]) {
                    this.categoryRefs[cat.id] = createRef();
                  }
                  return (
                    <div
                      key={cat.id}
                      ref={this.categoryRefs[cat.id]}
                      onClick={() => this.handleCategory(cat)}
                      style={{ display: "flex" }}
                    >
                      <Category
                        Data={cat}
                        Language={this.props.Language}
                        handleCategory={this.handleCategory}
                        Active={this.state.selectCategory.id === cat.id}
                        Index={index}
                      />
                    </div>
                  );
                }
              )}
            </>
          ) : (
            <SkeletonTheme baseColor="#FFFFFF12" highlightColor="#FFFFFF">
              <Skeleton height={50} />
            </SkeletonTheme>
          )}
        </div>
        <div className="items ani-ltr" id="itemContainer">
          <div className="listview">
            <span
              role="button"
              className={`custom-svg-listview ${
                this.state.listview == "two" ? "active" : ""
              }`}
              onClick={() => this.handleListview("two")}
              style={{
                display: "inline-flex",
                verticalAlign: "middle",
                cursor: "pointer",
              }}
            >
              <svg
                className={`${
                  this.state.listview == "two" ? "two-active" : "two-no-active"
                }`}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5 12H1.5M12.005 22L12.005 1M3 23H21C22.1046 23 23 22.1046 23 21V3C23 1.89543 22.1046 1 21 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23Z"
                  stroke-width="1.5"
                />
              </svg>
            </span>
            <span
              role="button"
              className={`custom-svg-listview ${
                this.state.listview == "list" ? "active" : ""
              }`}
              onClick={() => this.handleListview("list")}
              style={{
                display: "inline-flex",
                verticalAlign: "middle",
                cursor: "pointer",
              }}
            >
              <svg
                className={`${
                  this.state.listview == "list"
                    ? "list-active"
                    : "list-no-active"
                }`}
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2 17.5H3C3.82843 17.5 4.5 18.1716 4.5 19V20C4.5 20.8284 3.82843 21.5 3 21.5H2C1.17157 21.5 0.5 20.8284 0.5 20V19C0.5 18.1716 1.17157 17.5 2 17.5ZM8 17.5H20C20.8284 17.5 21.5 18.1716 21.5 19V20C21.5 20.8284 20.8284 21.5 20 21.5H8C7.17157 21.5 6.5 20.8284 6.5 20V19C6.5 18.1716 7.17157 17.5 8 17.5ZM2 8.5H3C3.82843 8.5 4.5 9.17157 4.5 10V13C4.5 13.8284 3.82843 14.5 3 14.5H2C1.17157 14.5 0.5 13.8284 0.5 13V10C0.5 9.17157 1.17157 8.5 2 8.5ZM8 8.5H20C20.8284 8.5 21.5 9.17157 21.5 10V13C21.5 13.8284 20.8284 14.5 20 14.5H8C7.17157 14.5 6.5 13.8284 6.5 13V10C6.5 9.17157 7.17157 8.5 8 8.5ZM2 0.5H3C3.82843 0.5 4.5 1.17157 4.5 2V4C4.5 4.82843 3.82843 5.5 3 5.5H2C1.17157 5.5 0.5 4.82843 0.5 4V2C0.5 1.17157 1.17157 0.5 2 0.5ZM8 0.5H20C20.8284 0.5 21.5 1.17157 21.5 2V4C21.5 4.82843 20.8284 5.5 20 5.5H8C7.17157 5.5 6.5 4.82843 6.5 4V2C6.5 1.17157 7.17157 0.5 8 0.5Z" />
              </svg>
            </span>
          </div>

          {this.state.load ? (
            <PhotoProvider
              maskOpacity={0.7}
              photoClassName={"photoProviderImg"}
              overlayRender={({ images, index }) => {
                if (!images[index]) {
                  return null;
                }
                const data = images[index].overlay;
                return (
                  <div
                    className={`item-photo-view`}
                    style={{ direction: isLtr ? "ltr" : "rtl" }}
                  >
                    <div>
                      <h5>
                        {this.props.Language === "en"
                          ? data.name_eng
                          : this.props.Language === "krd"
                          ? data.name_krd
                          : data.name_ar}
                      </h5>
                    </div>
                    <div className="price">
                      <span>
                        {" "}
                        {parseInt(data.price).toLocaleString("en-US")}
                      </span>{" "}
                      <span className="currency">
                        {this.props.Language === "en" ||
                        this.props.Language === "tr"
                          ? "IQD"
                          : "د.ع."}
                      </span>
                    </div>
                    <p>
                      {this.props.Language === "en"
                        ? data.desc_eng
                        : this.props.Language === "krd"
                        ? data.desc_krd
                        : data.desc_ar}
                    </p>
                  </div>
                );
              }}
            >
              {this.state.selectCategory.subCat ? (
                <div className="subcategories">
                  {this.state.selectCategory.subCategories.map((item) => (
                    <Subcategory
                      key={item.id}
                      Language={this.props.Language}
                      ListView={this.state.listview}
                      Category={item}
                      Items={this.state.items[item.id]}
                    />
                  ))}
                </div>
              ) : this.state.listview === "list" ? (
                this.state.items[this.state.selectCategory.id]?.map((item) => (
                  <List
                    key={item.id}
                    Data={item}
                    Language={this.props.Language}
                    addCartItem={this.props.addCartItem}
                    Cart={this.props.Cart}
                  />
                ))
              ) : (
                <div className="style-two">
                  {this.state.items[this.state.selectCategory.id]?.map(
                    (item, index) => (
                      <Two
                        key={item.id}
                        Data={item}
                        Language={this.props.Language}
                        addCartItem={this.props.addCartItem}
                        Index={index}
                        Length={
                          this.state.items[this.state.selectCategory.id]?.length
                        }
                      />
                    )
                  )}
                </div>
              )}
            </PhotoProvider>
          ) : (
            <SkeletonTheme baseColor="#FFFFFF12" highlightColor="#ffffff6b">
              <Skeleton count={5} height={216} />
            </SkeletonTheme>
          )}
        </div>

        <Cart
          Cart={this.props.Cart}
          SumPrice={this.props.SumPrice}
          SumQty={this.props.SumQty}
          Language={this.props.Language}
          Show={this.state.cart}
          clearCartItem={this.props.clearCartItem}
          updateCartItem={this.props.updateCartItem}
          HandleCartClose={this.handleCartClose}
        />
      </div>
    );
  }
}

export default Menu;
